import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import Chart from 'chart.js/auto';
import { ReportData } from "src/models/reportData";

@Component({
    selector: 'app-chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss'],
    standalone: true,
    imports: [IonicModule, CommonModule, FormsModule]
})
export class ChartComponent implements OnInit {
    @Input() data: ReportData[];
    @Input() chartType: string;
    @Input() index: number = 0;
    title: string;
    chart: any;
    chartId: string;
    chartData: any;

    ngOnInit(): void {
        if (this.data?.length > 0) {
            this.title = this.data[0].Title;
            this.chartId = `myChart${this.index}`;

            setTimeout(() => {
                let ctx = document.getElementById(this.chartId) as HTMLCanvasElement;

                this.chart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: this.data?.map(x => x.Label),
                        datasets: [
                            {
                                label: '',
                                data: [...this.data?.map(x => x.DataSetValue), 0],
                                fill: false,
                                borderColor: '#4BC0C0'
                            }
                        ]
                    },
                    options: {
                        maintainAspectRatio: true,
                        plugins: {
                            legend: {
                                position: 'top'
                            }
                        }
                    }
                });
            }, 500);
        }
    }
}